import { Badge } from '@/components/ui/badge'
import { stageBadgeVariant, stageLabel } from '@/hooks/use-contacts'
import { useLifecycleStages } from '@/hooks/use-lifecycle-stages'

/** Nhãn giai đoạn vòng đời theo màu và tên doanh nghiệp tự đặt. */
export function StageBadge({ stage, className }: { stage?: string | null; className?: string }) {
  const { colors, labels } = useLifecycleStages()
  const color = stage ? colors[stage] : null
  const text = stage ? (labels[stage] ?? stageLabel(stage)) : '—'
  if (color) {
    return (
      <Badge className={`border-transparent ${className ?? ''}`} style={{ backgroundColor: `${color}22`, color }}>
        {text}
      </Badge>
    )
  }
  return (
    <Badge variant={stageBadgeVariant(stage)} className={className}>
      {text}
    </Badge>
  )
}
